// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-2Iv7_","loader":"loader-20Qkt","rotation":"rotation-3dadK"};